import React, { useEffect, useState } from "react";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
// ui ORM
import CardSurgicalPosition from "./CardSurgicalPosition";
import CardTourniquet from "./CardTourniquet";
import CardElectricalXrayUltrasound from "./CardElectricalXrayUltrasound";
import CardDefibrillator from "./CardDefibrillator";
import CardLaser from "./CardLaser";
import { Button, Checkbox, Dropdown, Input } from "semantic-ui-react";
import TimeComboBox from "react-lib/apps/common/TimeComboBox";
import { useIntl } from "react-intl";

type CardStepAHProps = {
  // function
  onEvent: any;
  setProp: any;

  // CommonInterface
  buttonLoadCheck?: any;

  // select OR
  selectedOrOrder?: any;

  // options
  masterOptions?: any;

  // seq
  runSequence?: any;
  PerioperativeNursingSequence?: any;
};

const CardStepAHInitial: CardStepAHProps = {
  // funtion
  onEvent: () => null,
  setProp: () => null,

  // CommonInterface
  buttonLoadCheck: null,

  // select OR
  selectedOrOrder: {},

  // options
  masterOptions: {},

  // seq
  runSequence: null,
  PerioperativeNursingSequence: {},
};

const DEFAULT_PROPS = CardStepAHInitial
const CardStepAH: React.FC<CardStepAHProps> = (propsParam) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined)),
  };
  useEffect(() => {
    props.runSequence({
      sequence: "PerioperativeNursing",
      action: "FETCH_FORM_DATA_STEP_AH",
      
    });
  }, []);

  console.log(
    "props.PerioperativeNursingSequence",
    props.PerioperativeNursingSequence
  );
  return (
    <>
      <CardSurgicalPosition
        onEvent={props.onEvent}
        setProp={props.setProp}
        buttonLoadCheck={props.buttonLoadCheck}
        selectedOrOrder={props.selectedOrOrder}
        masterOptions={props.masterOptions}
        runSequence={props.runSequence}
        PerioperativeNursingSequence={props.PerioperativeNursingSequence}
        languageUX={props.languageUX}
      />
      <CardTourniquet
        onEvent={props.onEvent}
        setProp={props.setProp}
        buttonLoadCheck={props.buttonLoadCheck}
        selectedOrOrder={props.selectedOrOrder}
        masterOptions={props.masterOptions}
        runSequence={props.runSequence}
        PerioperativeNursingSequence={props.PerioperativeNursingSequence}
        languageUX={props.languageUX}
      />
      <CardElectricalXrayUltrasound
        onEvent={props.onEvent}
        setProp={props.setProp}
        buttonLoadCheck={props.buttonLoadCheck}
        selectedOrOrder={props.selectedOrOrder}
        masterOptions={props.masterOptions}
        runSequence={props.runSequence}
        PerioperativeNursingSequence={props.PerioperativeNursingSequence}
        languageUX={props.languageUX}
      />
      <CardDefibrillator
        onEvent={props.onEvent}
        setProp={props.setProp}
        buttonLoadCheck={props.buttonLoadCheck}
        selectedOrOrder={props.selectedOrOrder}
        masterOptions={props.masterOptions}
        runSequence={props.runSequence}
        PerioperativeNursingSequence={props.PerioperativeNursingSequence}
        languageUX={props.languageUX}
      />
      <CardLaser
        onEvent={props.onEvent}
        setProp={props.setProp}
        buttonLoadCheck={props.buttonLoadCheck}
        selectedOrOrder={props.selectedOrOrder}
        masterOptions={props.masterOptions}
        runSequence={props.runSequence}
        PerioperativeNursingSequence={props.PerioperativeNursingSequence}
        languageUX={props.languageUX}
      />
    </>
  );
};

export default React.memo(CardStepAH);
